module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ashley-correia-3213d7a3aa8d9c7a61335c3e9e981db5.jpg";